import FinanceDashboard from '@/orangehrmFinancePlugin/pages/FinanceDashboard.vue';
import CompanyExpenses from '@/orangehrmFinancePlugin/pages/CompanyExpenses.vue';
import PayrollWorkspace from '@/orangehrmFinancePlugin/pages/PayrollWorkspace.vue';
import MyPayslips from '@/orangehrmFinancePlugin/pages/MyPayslips.vue';

export default {
  'finance-dashboard': FinanceDashboard,
  'finance-expenses': CompanyExpenses,
  'finance-payroll': PayrollWorkspace,
  'finance-my-payslips': MyPayslips,
};
